/* Contact bar — hours, WhatsApp routing, Add to cart relay.
   Pairs with sections/sst-bar.liquid.

   Everything time-based runs here, in the browser, because Shopify caches
   rendered pages: a page built at 4pm would still say "open" at 9pm.
   Nairobi is UTC+3 all year (no daylight saving), so shifting the clock gives
   Nairobi time whatever zone the visitor's phone is set to.

   Testing without waiting for the clock: ?wa=night forces "closed",
   ?wa=day forces "open" — same switch as the live product page button. */
(function () {
  'use strict';

  var bar = document.querySelector('[data-sst-bar]');
  if (!bar) return;

  /* ---------- shop hours (Nairobi) ----------
     day of week (0 = Sunday) → [open hour, close hour]. Missing = closed. */
  // Copied in assets/kcse-practicals.js (KCSE page has no contact bar) — change both.
  var HOURS = { 1: [8, 17], 2: [8, 17], 3: [8, 17], 4: [8, 17], 5: [8, 17], 6: [8, 13] };
  var DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  function nairobiNow() {
    var d = new Date(Date.now() + 3 * 60 * 60 * 1000);
    return { day: d.getUTCDay(), hour: d.getUTCHours() + d.getUTCMinutes() / 60 };
  }

  function isOpen(now) {
    if (/[?&]wa=night/.test(location.search)) return false;
    if (/[?&]wa=day/.test(location.search)) return true;
    var h = HOURS[now.day];
    return !!h && now.hour >= h[0] && now.hour < h[1];
  }

  function fmtHour(h) {
    if (h === 0) return '12am';
    if (h === 12) return '12pm';
    return h < 12 ? h + 'am' : (h - 12) + 'pm';
  }

  // "Opens 8am", "Opens 8am tomorrow", "Opens 8am Mon"
  function nextOpening(now) {
    for (var i = 0; i < 8; i++) {
      var d = (now.day + i) % 7;
      var h = HOURS[d];
      if (!h) continue;
      if (i === 0 && now.hour >= h[0]) continue;
      var when = i === 0 ? '' : i === 1 ? ' tomorrow' : ' ' + DAY_NAMES[d];
      return 'Opens ' + fmtHour(h[0]) + when;
    }
    return 'Closed';
  }

  // Shared with the delivery card (sst-delivery.js) for WhatsApp routing.
  window.sstShopOpen = function () { return isOpen(nairobiNow()); };

  var call = bar.querySelector('[data-sst-bar-call]');
  var callSub = bar.querySelector('[data-sst-bar-hours]');
  // Every hours-routed WhatsApp link on the page: the bar's, plus the
  // product page's Order on WhatsApp and bulk pricing buttons.
  var waLinks = document.querySelectorAll('[data-sst-wa-route]');

  function refresh() {
    var now = nairobiNow();
    var open = isOpen(now);
    if (call) {
      call.classList.toggle('is-closed', !open);
      if (callSub) callSub.textContent = open ? 'Open now' : nextOpening(now);
    }
    // Shop phone while open, Amina otherwise. The ref code is added after
    // this by the attribution script (snippets/ss-attribution.liquid).
    waLinks.forEach(function (a) {
      a.setAttribute('href', open ? a.dataset.day : a.dataset.night);
    });
  }

  refresh();
  setInterval(refresh, 60 * 1000);
  waLinks.forEach(function (a) { a.addEventListener('click', refresh); }); // page left open since 16:55

  /* ---------- Add to cart relay (product mode) ----------
     Clicks the page's own add-to-cart button, so the theme's <product-form>
     handles it and the cart drawer opens exactly as it does today. Works on
     the live template (main-product) and the redesign (data-sst-add). */
  var add = bar.querySelector('[data-sst-bar-add]');
  if (!add) return;
  var addText = add.querySelector('[data-sst-bar-add-text]');
  var addLabel = addText ? addText.textContent : 'Add to cart';

  function mainSubmit() {
    var b = document.querySelector('[data-sst-add]');
    if (b) return b;
    var forms = document.querySelectorAll('product-form form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      // skip quick-add / recommendation cards further down the page
      if (forms[i].closest('quick-add-modal, .card-wrapper, product-recommendations, .quick-add')) continue;
      var s = forms[i].querySelector('[type="submit"]');
      if (s) return s;
    }
    return null;
  }

  var target = mainSubmit();
  if (!target) return; // no buy button on this template — bar stays Call · WhatsApp
  var picker = document.querySelector('[data-sst-opts]'); // redesign's variant picker
  add.hidden = false;
  bar.classList.add('has-add');

  function isOff() {
    return target.disabled || target.getAttribute('aria-disabled') === 'true';
  }

  function sync() {
    // Disabled main button + a picker = options not chosen yet (redesign);
    // disabled with no picker = sold out / unavailable.
    var off = isOff();
    var needsChoice = off && !!picker;
    add.disabled = off && !needsChoice;
    if (addText) {
      var t = (target.textContent || '').trim();
      addText.textContent = off && !needsChoice && t ? t : addLabel;
    }
  }

  sync();
  new MutationObserver(sync).observe(target, {
    attributes: true, attributeFilter: ['disabled', 'aria-disabled'], childList: true, subtree: true, characterData: true
  });

  add.addEventListener('click', function () {
    if (picker && isOff()) {
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var hint = document.querySelector('[data-sst-hint]');
      if (hint) hint.hidden = false;
      return;
    }
    target.click();
  });
})();
